import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';
import './nlp/imageclassify.css';
import bulk from './nlp/imageclassify.js';
import './panel.css';
// import './jquery-simple-upload.css';
// import '@kanety/jquery-simple-upload';

function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function error( s ) {
    var err = $('<div role="alert" class="fade alert alert-danger show">').html(s);
	$('.maincontent').html('').append(err);
}


function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var descriptor = {
	"labels": null,
	"dataset": null,
	"imageLayout": {
		"showLabels": true,
		"showDetails": true,
		"showControls": false
	},
	"detailLayout": {
		"policy": "doubleclick",
		"doubleSize": 2,
		"showLabels": true,
		"showDetails": true,
		// "showControls": true
	},
	"imageControls": {
		"redAdjust": true,
		"greenAdjust": true,
		"blueAdjust": false,
		"brigtnessAdjust": true
	},
	"gridLayout": {
		"imageZoom": 10,
		"itemsPerPage": 40,
		"filter": {
			"globalFilter": true,
			"keyFilter": true,
			"annotation": true
		},
		"toggleLabels": false,
		"toggleDetails": true,
		"toggleControls": true
	},
	"userRole": {
		// "email": "marcelo@me.com",
		// "role": "nlp_an"
		"role": "admin",
	},
	// "classificationMode": true,
	"selectionMode": "multi",
	"blockEdit": true,
    "datasetMode": true,
}


var global = window.GlobalVars;
var tasks = null;
var project = null;

function DatasetAdvanced(prop) {

    var global = window.GlobalVars;
    var tab;

	function start() {
		var cfg = window.getPageParams();
		var datasetId = cfg.did || global.currentDatasetId;
		console.log( 'CFG', cfg, datasetId )
		descriptor.presignedConfig = {dataset:datasetId};
		// var match = {datasetId:datasetId};
		var match = {}
		descriptor.baseMatch = {type:'dataset','key':'itemId',match:match,state:0};
		console.log( 'baseMatch', descriptor.baseMatch );
		
		var getSize = 200000;
		var getSize = 200;
        descriptor.datasetGlobalSearch = true;
		descriptor.gridLayout.rolloverPreview = true;

		descriptor.progressiveLoad = function( config, callback) {
			var start = config.start;
			var filter = config.filter;
			var end = config.end || 0;
			var limit = end > 0 ? end-start+1 : getSize;
			if (!filter) filter = {};
			if( !config.noLoading ) frm.loading('Loading Items');
			var inProgress = false;
			var exportProgress;
			function showProcessing(progress) {
				if (!inProgress) {
					inProgress = true;
					frm.myAlert('Dataset processing', 'Dataset items are being processed, please wait.', 'Close', function () {
						window.goPage('datasets')
					});
					exportProgress = new frm.progressBar($('.modal-body'));
					// $('.modal-footer').hide();
				}
				exportProgress.set(progress)
				setTimeout(getItems, 2000);
			}
			function getItems() {
				var gmatch = clone(descriptor.baseMatch.match);
				if( Object.keys(filter).length ) gmatch.filter = filter;
				gmatch._start = start;
				gmatch._limit = limit;
				console.log( 'GMATCH', JSON.stringify(gmatch) )
				window.post('dataset_items', gmatch, res => {
					if ('progress' in res.data) return showProcessing(res.data.progress);
					console.log('dataset_items', res);
					if (inProgress) frm.myAlertClose();
					descriptor.filterData = res.data.filter;
					if (res.data.start == 0) {
						descriptor.dataset = [];
						descriptor.dataset[res.data.count - 1] = null;
					}
					for (var i = 0; i < res.data.records.length; i++)
						descriptor.dataset[i + start] = res.data.records[i];
					if (descriptor.dataset.length == 0 && !Object.keys(filter).length ) {
						frm.loadingOut();
						return error('No documents found')
					}
					frm.loadingOut();
					callback(res.data.records);
				})
			}
			getItems();
		}
		descriptor.configId = 'di-' + datasetId;
		descriptor.config = cfg.cfg || ((global.config || {})[descriptor.configId] || '');
		descriptor.configLock = cfg.cfg > '';
		descriptor.labels = [];
		if (window.hasPriv('admin', 'c_admin', 'd_super')) descriptor.blockEdit = false;

		window.post('find_datasets', { match: match }, dres => {
			console.log('DATASET', dres.data)
			var datasetData = dres.data.records[0]
			$('#pageTitle').find('span').html(datasetData.datasetName);
			descriptor.datasetData = datasetData;
			descriptor.dataset = [];
			var ftr = bulk.initFilter(descriptor);
			descriptor.progressiveLoad({
				start:0, 
				filter: ftr,
			}, () => {
				bulk.init(descriptor)
			})
			// console.log( 'datasetData', datasetId, clone(datasetData), clone(datasetData.tags) )

			// var inProgress = false;
			// var exportProgress;
			// function showProcessing( progress ) {
			// 	if( !inProgress ) {
			// 		inProgress = true;
			// 		frm.myAlert('Dataset processing', 'Dataset items are being processed, please wait.', 'Close', function(){
			// 			window.goPage('datasets')
			// 		} );
			// 		exportProgress = new frm.progressBar($('.modal-body'));
			// 		// $('.modal-footer').hide();
			// 	}
			//     exportProgress.set(progress)
			// 	setTimeout( getItems, 2000 );
			// }
			// function getItems() {
			// 	window.post('dataset_items', { datasetId: datasetData.datasetId || '###' }, res => {
			// 		if( 'progress' in res.data ) return showProcessing( res.data.progress );
			// 		console.log( 'dataset_items', res );
			// 		if( inProgress ) frm.myAlertClose();
			// 		descriptor.filterData = res.data.filter;
			// 		descriptor.dataset = res.data.records;
			// 		if( window.hasPriv('admin', 'c_admin', 'd_super')) descriptor.blockEdit = false;
			// 		if( descriptor.dataset.length == 0 ) {
			// 			frm.loadingOut();
			// 			return error( 'No documents found' )
			// 		}
			// 		// console.log( 'DESCCFG', descriptor.config )
			// 		// for (var l of Object.values(res.data.labels)) {
			// 		// 	descriptor.labels.push({ label: l.name });
			// 		// }
			// 		// console.log( 'descriptor', descriptor )
			// 		bulk.init(descriptor)
			// 		frm.loadingOut();
			// 	})
			// }
			// getItems();
		})
	}

    useEffect( start );

    return (
		<>
			<div fluid="md p-0" className="imgcls-main maincontent">
				<div className="imgcls-toolbar hidden">
					<div className="imgcls-toolbar-commands"></div>
					<div className="imgcls-toolbar-filters"></div>
					<div className="imgcls-toolbar-sort"></div>
					<div className="imgcls-toolbar-project"></div>
					<div className="imgcls-toolbar-tabs"></div>
					<div className="imgcls-toolbar-controls">
						<div className="imgcls-toolbar-sliders"></div>
						<div className="imgcls-toolbar-nav-placeholder"></div>
						<div className="imgcls-toolbar-nav"></div>
						<div className="imgcls-toolbar-buttons-placeholder"></div>
						<div className="imgcls-toolbar-buttons">
							<span className="selected-images"></span>
						</div>
					</div>
				</div>
				<div className="imgcls-browse">
				</div>
			</div>
		</>
    )
}

export default DatasetAdvanced;
